/* eslint-disable @typescript-eslint/naming-convention */
import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, OpenPlayerSessionResult } from '../types';
import { EVENTS, isAllowedPlatformParams } from '../constants';
import { mapTagsParams } from './mapTagsParams';

export const mapOpenPlayerSession = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): OpenPlayerSessionResult => {
    const video_series_title =
        payload.payload.asset?.seriesTitle || payload.payload.seriesData?.series?.title;
    const video_episode_number = payload.payload.asset?.episodeNumber?.toString();
    const video_season_number = payload.payload.asset?.seasonNumber?.toString();
    const channel_number = payload.payload.asset?.channel?.number?.toString();
    const channel_title = payload.payload.asset?.channel?.label;
    return {
        ...(isAllowedPlatformParams ? { ...mapTagsParams(payload) } : {}),
        language: payload.language,
        session_id: payload.payload.sessionId,
        is_authenticated: payload.userId ? 1 : 0,
        event: EVENTS.OPEN_PLAYER_SESSION,
        event_trigger: triggerName,
        video_asset_id: payload.payload.asset?.id,
        video_title: payload.payload.asset?.title as string,
        video_external_id: payload.payload.asset?.externalId as string,
        content_type: payload.payload.asset?.type,
        ...(video_series_title ? { video_series_title } : {}),
        ...(video_episode_number ? { video_episode_number } : {}),
        ...(video_season_number ? { video_season_number } : {}),
        ...(channel_number ? { channel_number } : {}),
        ...(channel_title ? { channel_title } : {}),
    };
};
